import { action } from 'mobx';
import { v4 as uuid } from 'uuid';
import { BaseBlueprintFormVM } from '../../../../blueprint-form-base.viewmodel';
import { TConnection } from '../../../../../../api/blueprints/connection.template.types';
import { FormVmItemConfigType, FormVmValueType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { ConnectionVersion } from '../../../../../../constants/common.constants';
import { FieldKey as KnovioConnectionFieldKey } from './knovio-connection/connection-knovio-form.config';
import { transpileClassesToInlineStyles } from '../../../../../global/rich-text-editor/utils/transpiler';

export class BaseConnectionFormVM extends BaseBlueprintFormVM {
    protected connectionId: string;
    protected isDefaultConnection: boolean;

    constructor(
        protected connection: TConnection,
        protected configList: FormVmItemConfigType[],
        protected readonly addConnection: (connection: TConnection) => void,
        protected readonly editConnection: (connection: TConnection) => void,
        protected readonly connectionVersion: ConnectionVersion = ConnectionVersion.V1,
    ) {
        super();
        this.initFormVM(configList, connection);
    }

    public get isEditMode(): boolean {
        return !!this.connectionId;
    }

    public isV2ConnectionVersion = (): boolean => {
        return this.connectionVersion === ConnectionVersion.V2;
    };

    public submitForm(): void {
        const dto = this.composeConnectionValues();

        if (!this.formDataCtrl.isVmValid()) {
            this.formDataCtrl.setVmTouched();
            return;
        }

        return this.isEditMode
            ? this.editConnection(dto)
            : this.addConnection(dto);
    };

    @action
    protected initFormVM(configList: FormVmItemConfigType[], connection: TConnection): void {
        if (connection) {
            this.connectionId = connection.connectionId;
            this.isDefaultConnection = connection.isDefaultConnection;
        }

        this.initializeFormData(configList, connection);
    }

    protected composeConnectionValues(): TConnection {
        const connectionId = this.connectionId || uuid();
        const values = {
            connectionId: connectionId,
            isDefaultConnection: this.isDefaultConnection || false,
        } as TConnection;

        this.formDataCtrl.getVmState().forEach(({ name, value }) => {
            // Since CKEditor works with classes, but data is stored with inline styles,
            // all CKEditor values need to be converted to the appropriate format
            values[name] = this.transpileFieldValueIfFromCKEditor(name, value);
        });

        return values;
    };

    private transpileFieldValueIfFromCKEditor = (name: string, value: FormVmValueType): FormVmValueType => {
        return name === KnovioConnectionFieldKey.STANDBY_MESSAGE
            ? transpileClassesToInlineStyles(String(value))
            : value;
    };
}
